export default function EmptyTableRow() {
    return (
        <tr>
            <td className="text-center" colSpan={100}>
                No results
            </td>
        </tr>
    );
}
